export { login } from 'next-flight-server-reference-proxy-loader?id=7fbffcf8c40c93a2c44edea4c8f3e126b8917e2b12&name=login!'